<template>
    <div class="profileNavigation">
        <nav class="nav">
            <div class="navItems">
                <Button
                    tabindex="0"
                    appearance="tabButton"
                    size="large">
                    <span class="emphasized"></span> {{ siteContent.entries }}
                    <div class="indicator"></div>
                </Button>
                <Button
                    tabindex="0"
                    appearance="tabButton"
                    size="large">
                    <span class="emphasized"></span> {{ siteContent.drafts }}
                </Button>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        name: 'ProfileNavigationSkeleton'
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .profileNavigation {
        display: flex;
        position: relative;
        width: 100%;
        z-index: 1;
        margin-bottom: 2rem;
    }

    .nav {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
    }

    .navItems {
        display: flex;
        color: var(--color-white-important);
        align-items: center;
    }

    @media all and (max-width: 720px) {
        .profileNavigation {
            overflow-x: scroll;
            padding: 0 1rem;

            &::-webkit-scrollbar {
                display: none;
            }
        }
    }
</style>
